// extracted by mini-css-extract-plugin
export default {"content":"lab-category-delete_content__4Hs0Z","buttons":"lab-category-delete_buttons__GRdYp","button":"lab-category-delete_button__9LmQ6"};